import _ from "lodash";
import React, { useState } from "react";
import moment from "moment";
import * as csv from "fast-csv";
import Button from "components/Shared/Button";
import TextInputField from "components/Shared/TextInputField";
import { fetchWorkflowReport } from "services/report";
import useReportData from "../useReportData";
import { useSelector } from "react-redux";

const WorkflowReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const specialistProfiles = useSelector((state) => state.app.specialistProfiles);

  const validationError =
    startDate && endDate && startDate > endDate ? "The start date can not be date after end date!" : "";
  const isReady = Boolean(startDate) && Boolean(endDate) && !validationError;

  const { isLoading, failureReason, info, isEmpty, scheduleLoad, loadNow, download } = useReportData({
    cacheKey: `${startDate}~${endDate}~${JSON.stringify(
      specialistProfiles.map(({ id, specialties }) => [id, specialties?.[0]?.name || ""])
    )}`,
    isReady,
    fileName: `workflow_report_${startDate}-${endDate}.csv`,
    infoMessage: `Praparing workflow report(${startDate} - ${endDate})...`,
    emptyMessage: "No availiable workflows in given range",
    loadCsv: async () => {
      const columnsNamingMap = {
        client: "Client",
        urn: "URN",
        category: "Category",
        DOB: "DOB",
        hospital: "Hospital",
        specialty: "Specialty",
        createdAt: "Creation Date",
        practitioner: "Case Manager",
        appointmentDate: "Appointment Date",
        newOrReview: "New or Review",
        expiryDate: "Referrer Expiry Date",
        dueWeeks: "Due Weeks",
        status: "Status",
        archived: "Archived",
      };
      const data = await fetchWorkflowReport({ startDate, endDate, specialistProfiles });
      const reportRawData = data?.map((data) => ({
        ...data,
        createdAt: !_.isNil(data.createdAt) ? moment.unix(data.createdAt).format("YYYY-MM-DD HH:mm") : "",
        appointmentDate: !(_.isNil(data.appointmentDate) || _.isEmpty(data.appointmentDate))
          ? moment(data.appointmentDate, "YYYY-MM-DDTHH:mm:ss Z").format("YYYY-MM-DD HH:mm")
          : "",
      }));
      if (!reportRawData?.length) {
        return { rowCount: 0 };
      }
      const rows = [Object.keys(reportRawData[0]).map((key) => columnsNamingMap[key] || key)].concat(
        reportRawData.map((data) => Object.values(data).map((a) => (a === null ? "" : a.toString())))
      );
      return { csv: await csv.writeToString(rows), rowCount: reportRawData.length };
    },
  });

  return (
    <>
      <p className="menu-label">Workflows Report</p>
      <div className="columns">
        <div className="column is-one-quarter">
          <TextInputField
            label="Start date"
            isRequired={true}
            hasError={false}
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              scheduleLoad();
            }}
            onBlur={loadNow}
            placeholder={moment().format("YYYY-MM-DD")}
            type="date"
          />
        </div>
        <div className="column is-one-quarter">
          <TextInputField
            label="End date"
            isRequired={true}
            hasError={false}
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              scheduleLoad();
            }}
            onBlur={loadNow}
            placeholder={moment().format("YYYY-MM-DD")}
            type="date"
          />
        </div>
      </div>
      <Button
        isFullWidth={false}
        disabled={!isReady || isLoading || isEmpty}
        isLoading={isLoading}
        onClick={download}
        text="Download"
      />
      <p className="has-text-danger is-size-7">{validationError || failureReason}</p>
      <p className="has-text-info is-size-7">{info}</p>
    </>
  );
};

export default WorkflowReport;
